import React, { createContext, useContext, useState, ReactNode } from 'react';


type NotificationType = string | null;

interface NotificationState {
  content: string;
  type: NotificationType;
}

type NotificationMethods={
  info: (content: string) => void;
  success: (content: string) => void;
  warning: (content: string) => void;
  error: (content: string) => void;
  }
  
  interface NotificationContextProps {
    notification: NotificationState;
    notify: NotificationMethods;
  }
  

// interface NotificationContextProps {
//   notification: NotificationState;
//   notify: (content: string, type: NotificationType) => void;
// }

const NotificationContext = createContext<NotificationContextProps | undefined>(undefined);

type Props = {
  children: ReactNode;
}

export const useNotification = (): NotificationContextProps => {
    const context = useContext(NotificationContext);
    if (!context) {
      throw new Error('useNotification must be used within a NotificationProvider');
    }
    return context;
  };

export const NotificationProvider = ({ children }:Props) => {

  const [notification, setNotification] = useState<NotificationState>({
    content: '',
    type: null,
  });

//   const notify = (content: string, type: NotificationType) => {
//     setNotification({ content, type });
//   };

  class ToastNotify {
   
    success(content:string){

        setNotification({ content, type:'success' });
    }

    warning(content:string){

        setNotification({ content, type:'warning' });
    }

    error(content:string){

        setNotification({ content, type:'error' });
    }

    info(content:string) {
        setNotification({ content, type: null });
      }
  }

  const notify = new ToastNotify()

  return (
    <NotificationContext.Provider value={{ notification, notify }}>
      {children}
    </NotificationContext.Provider>
  );
};



